import { render } from "./HeroiconsSolidTable.vue?vue&type=template&id=2d5105a1"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTable.vue"]])

export default __exports__